export default "__VITE_ASSET__a59c158b__"